import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const AiSearchResultsError = () => {
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    flexGrow: 1,
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      type: "error",
      title: I18n.text('reports.aiSearch.errorHeading'),
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.aiSearch.errorSubheading"
        })
      })
    })
  });
};
export default AiSearchResultsError;